import { Injectable } from '@angular/core';
import { StudentInfo } from '../shared/interfaces/student-info';

@Injectable({
  providedIn: 'root',
})
export class StudentStore {
  initializeSelectedStudent(student: StudentInfo): void {
    this.studentInfo = student;
    localStorage.setItem('nycId', this.studentInfo.nycId);
  }

  initializeSelectedStudentId(studentId: string): void {
    localStorage.setItem('nycId', studentId);
  }

  getnycIdFromLocalStorage(): string {
    const nycId = localStorage.getItem('nycId');
    return (nycId ? nycId : '');
  }

  isPreSchoolStudent(dob: Date): boolean {
    const dobYear = dob.getFullYear();
    const currentYear = new Date().getFullYear();

    if (currentYear - dobYear < 5) {
      return true;
    }
    else {
      return false;
    }
  }

  get SelectedStudentInfo(): StudentInfo {
    return this.studentInfo;
  }

  private studentInfo: StudentInfo;
}
